<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.4578 8.3294L3.2162 6.4616L3.9842 5.5394L5.3432 6.671L7.9568 3.7964L8.8442 4.604L5.4578 8.3294ZM6.00019 1.2002C3.34939 1.2002 1.2002 3.3494 1.2002 6.0002C1.2002 8.65099 3.34939 10.8002 6.00019 10.8002C8.65159 10.8002 10.8002 8.65099 10.8002 6.0002C10.8002 3.3494 8.65159 1.2002 6.00019 1.2002Z"
      fill="#46C490"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconGreenCheck',
};
</script>
